import { useState } from 'react'
import { api } from '@lib/orpc-client'
import * as Sentry from '@sentry/react'

export interface PostpaidInquiryResult {
  ref_id: string
  customer_no: string
  customer_name?: string
  buyer_sku_code: string
  admin: number
  message: string
  status: string
  rc: string
  buyer_last_saldo: number
  price: number
  selling_price: number
  selling_price_net: number
  admin_fee: number
  platform_fee: number
  desc?: {
    lembar_tagihan?: number
  },
  ppob_inquiry_quote_uuid: string
}

interface PostpaidInquiryResponse {
  success: boolean
  data: PostpaidInquiryResult
}

export const usePostpaidInquiry = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const inquirePostpaid = async (
    buyerSkuCode: string,
    customerNo: string,
  ): Promise<PostpaidInquiryResult | null> => {
    setIsLoading(true)
    setError(null)

    try {
      const response = await api.wallet.ppob.postpaidInquiry({
        buyer_sku_code: buyerSkuCode,
        customer_no: customerNo,
      }) as PostpaidInquiryResponse

      if (response.success) {
        return response.data
      } else {
        setError(response.data.message || 'Inquiry failed')
        return null
      }
    } catch (err: any) {
      const errorMessage = err.responseBody?.error?.message || err.message || 'Failed to inquire postpaid bill'
      setError(errorMessage)
      Sentry.captureException(err, {
        tags: { feature: 'ppob', service: 'postpaid-inquiry' },
        extra: { buyerSkuCode, customerNo }
      })
      return null
    } finally {
      setIsLoading(false)
    }
  }

  return {
    inquirePostpaid,
    isLoading,
    error
  }
}
